import { Modal, ModalProps } from "@mantine/core";
import { useEffect } from "react";

import { useGetApi } from "../../../hooks";
import { StyledTable, StyledTd, StyledTh, StyledTr } from "../../../styled";
import { DateTimeDisp } from "../DateTime";

interface Props {
  opened: boolean;
  close: () => void;
  elementName?: string;
  params: any;
  apiUrl: string;
  dataHeaders?: string[];
  dataKeys?: string[];
  [key: string]: ModalProps[keyof ModalProps];
}

const HistoryModal = ({
  opened,
  close,
  params,
  apiUrl,
  elementName,
  dataHeaders,
  dataKeys,
  ...modalProps
}: Props) => {
  const { data, refetch } = useGetApi<{ list: any }>({
    request: apiUrl,
    fetchOnInit: false,
    mapper: (data) => {
      return { list: data?.list ?? data?.data ?? [] }
    }
  });

  useEffect(() => {
    if (opened && params)
      void refetch({
        params,
      });
  }, [params]);

  const showCustomData =
    dataHeaders && dataKeys && data?.list && data.list.length > 0;

  return (
    <Modal
      title={
        <span>
          History for{" "}
          <span style={{ fontWeight: 200 }}>{elementName ?? ""}</span>
        </span>
      }
      opened={opened}
      onClose={close}
      size="xl"
      {...modalProps}>
      {data?.list && data.list.length > 0 ? (
        <StyledTable style={{ fontSize: 14 }}>
          <StyledTr>
            {showCustomData &&
              dataHeaders.map((header: string) => (
                <StyledTh key={header}>{header}</StyledTh>
              ))}
            <StyledTh>Action</StyledTh>
            <StyledTh>User</StyledTh>
            <StyledTh>Date</StyledTh>
          </StyledTr>
          {data.list.map((row: any) => (
            <StyledTr key={row.id}>
              {showCustomData &&
                dataKeys.map((key: string) => (
                  <StyledTd key={key}>{row.data?.[key]}</StyledTd>
                ))}
              <StyledTd>{row.action}</StyledTd>
              <StyledTd>{row.detail}</StyledTd>
              <StyledTd>
                <DateTimeDisp lt={row.date ?? row.createddateLT} utc={row.dateUTC ?? row.createddateUTC} color="text" />
              </StyledTd>
            </StyledTr>
          ))}
        </StyledTable>
      ) : (
        <div style={{ textAlign: "center" }}>No history was found</div>
      )}
    </Modal>
  );
};

export default HistoryModal;
